import axios from 'axios'

axios('/icons.svg').then(({ data }) => document.body.insertAdjacentHTML('afterbegin', data))
